module.exports = __webpack_public_path__ + "static/1-712ebd28edc831567a0e4206079f094f.png";